export function getConfig() {
  return {
    BACKEND_URL: import.meta.env.VITE_BACKEND_URL,
    FORTNOX_AUTH_URL: import.meta.env.VITE_FORTNOX_AUTH_URL,
    FORTNOX_CLIENT_ID: import.meta.env.VITE_FORTNOX_CLIENT_ID,
    ENTRA_CLIENT_ID: import.meta.env.VITE_ENTRA_CLIENT_ID,
    ENTRA_TENANT_ID: import.meta.env.VITE_ENTRA_TENANT_ID,
    SHAREPOINT_CLIENT_ID: import.meta.env.VITE_SHAREPOINT_CLIENT_ID,
    SHAREPOINT_TENANT_ID: import.meta.env.VITE_SHAREPOINT_TENANT_ID,
    // Dev-only escape hatch, "true" to enable — see services/graph/mail-token.ts. Additionally gated on
    // import.meta.env.DEV, so it cannot take effect in a production build whatever this is set to.
    MAIL_FROM_SHAREPOINT_TENANT: import.meta.env.VITE_MAIL_FROM_SHAREPOINT_TENANT,
    NODE_ENV: import.meta.env.VITE_NODE_ENV,
  };
}

export const businessConfig = {
  cesg: {
    ab: 'CESG AB',
    organizationNumber: '55 9456-0079',
    website: 'www.cesg.se',
    address: {
      zip: '111 40',
      street: 'Döbelnsgatan',
      streetNumber: '21',
      city: 'Stockholm',
      region: 'Stockholms län',
    },
  },
} as const;
